/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewdefaulttype3Inputs */

const en_ticketpreviewdefaulttype3 = /** @type {(inputs: Ticketpreviewdefaulttype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const de_ticketpreviewdefaulttype3 = /** @type {(inputs: Ticketpreviewdefaulttype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintritt`)
};

/**
* | output |
* | --- |
* | "Entry" |
*
* @param {Ticketpreviewdefaulttype3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewdefaulttype3 = /** @type {((inputs?: Ticketpreviewdefaulttype3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewdefaulttype3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewdefaulttype3(inputs)
	return de_ticketpreviewdefaulttype3(inputs)
});
export { ticketpreviewdefaulttype3 as "ticketPreviewDefaultType" }